import { Injectable } from '@angular/core';

/**
 * Thin wrapper around `window.location` so navigation side-effects can be mocked in unit tests.
 * `window.location.href` is non-configurable per browser spec and cannot be spied on directly.
 */
@Injectable({
  providedIn: 'root'
})
export class WindowLocationService {
  get origin(): string {
    return window.location.origin;
  }

  get href(): string {
    return window.location.href;
  }

  redirect(url: string): void {
    window.location.href = url;
  }

  reload(): void {
    window.location.reload();
  }
}
